import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import './App.css';
import { getBlogPosts } from './blogData';

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(() => getBlogPosts().find(p => p.slug === slug) || null);

  useEffect(() => {
    const currentPost = getBlogPosts().find(p => p.slug === slug);
    setPost(currentPost || null);

    if (currentPost) {
      document.title = `${currentPost.title} - Celebrity Cuts Blog`;
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute('content', currentPost.description);
      }
    } else {
      document.title = 'Blog Post Not Found - Celebrity Cuts Blog';
    }
  }, [slug]);

  if (!post) {
    return (
      <div className="blog-page">
        <div className="blog-container">
          <h1>Blog Post Not Found</h1>
          <Link to="/blog" className="blog-back-link">← Back to Blog</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-page">
      <div className="blog-container">
        <Link to="/blog" className="blog-back-link">← Back to Blog</Link>

        <div className="blog-single-post">
          <div className="blog-post-image">
            <img src={post.image} alt={post.title} />
          </div>
          <div className="blog-post-content">
            <div className="blog-post-meta">
              <span className="blog-category">{post.category}</span>
              <span className="blog-date">{post.date}</span>
            </div>
            <h1 className="blog-post-title">{post.title}</h1>
            <p className="blog-post-description">
              {post.description}
              <a href="https://celebritycuts.in/" target="_blank" rel="noopener noreferrer" className="blog-link">{post.descriptionWithLink}</a>
              {post.descriptionAfterLink}
            </p>

            {post.sections && post.sections.length > 0 ? (
              <div className="blog-sections">
                {post.sections.map((section, index) => (
                  <div key={index} className="blog-section">
                    <h2>{section.heading}</h2>
                    <p>{section.content}</p>
                  </div>
                ))}
              </div>
            ) : post.content ? (
              <div className="blog-sections">
                {post.content.split('\n').filter(Boolean).map((line, index) => (
                  <p key={index}>{line}</p>
                ))}
              </div>
            ) : null}

            {post.conclusion && (
              <div className="blog-conclusion">
                <h2>Final Thoughts</h2>
                <p>{post.conclusion}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default BlogPost;